import { ActionTree, GetterTree, MutationTree } from "vuex";
import { RefreshableRequestHelper } from "@/helpers/RefreshableRequestHelper";
import { KokattoConfigServiceClient } from "@/serviceClients/KokattoConfigServiceClient";
import { KokattoGetCSPlatformConfigResponse } from "@/serviceClients/responses/KokattoGetCSPlatformConfigResponse";
import {
  KokattoErrorResponse,
  isKokattoErrorResponse,
} from "@/serviceClients/responses/KokattoErrorResponse";
import { CSPConfiguration } from "@/models/CSPConfiguration";

interface State {
  configuration: CSPConfiguration;
}

const DEFAULT_STATE: State = {
  configuration: {
    featureCs: 0,
    isAutoAssignFeature: false,
    isDisplayChatroomEmoji: false,
    isDisplayChatroomAttachment: false,
    isDisplayChatroomCSName: false,
    featureManager: 0,
    isFetchFromContact: false,
  },
};

const state: State = { ...DEFAULT_STATE };

const getters: GetterTree<State, any> = {
  getConfiguration: (state) => state.configuration,
  getHidePhoneNumbers: (state, getters, rootState, rootGetters) => {
    const csRole = rootGetters.getCsRole ?? "";
    const isSpv = csRole.toLowerCase().includes("spv");
    if (isSpv) {
      return (state.configuration.featureManager & 128) > 0;
    }
    return (state.configuration.featureCs & 128) > 0;
  },
  getIsFetchFromContact: (state) =>
    state.configuration.isFetchFromContact ?? false,
};

const mutations: MutationTree<State> = {
  setConfiguration(state, payload: CSPConfiguration) {
    // The API response is authoritative. Reset to defaults first so a field the
    // backend stops sending reverts to its default instead of keeping a stale
    // value (which vuex-persist would otherwise rehydrate forever).
    state.configuration = {
      ...DEFAULT_STATE.configuration,
      ...payload,
    };
  },
};

const actions: ActionTree<State, any> = {
  async getCSPConfiguration({ commit }) {
    try {
      const response:
        | KokattoGetCSPlatformConfigResponse
        | KokattoErrorResponse = await RefreshableRequestHelper.requestKokatto<KokattoGetCSPlatformConfigResponse>(
        () => {
          const kokattoConfigServiceClient = new KokattoConfigServiceClient();
          return kokattoConfigServiceClient.getConfig();
        }
      );

      if (!isKokattoErrorResponse(response)) {
        commit("setConfiguration", response.configuration);
      }
    } catch (error) {
      console.error("[ERROR] getCSPConfiguration() - CSPConfiguration", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
